<template>
  <div >
    <v-text-field class="ml-1" id="username" label="User Name/Email"></v-text-field>
    <v-text-field class="ml-1" id="password" type="password" label="Password"></v-text-field>
    <v-btn @click="login()">Login</v-btn>
    <v-btn v-if="admin" @click="getData()">Get Data</v-btn>
    <div>
        <table style="width:100%">
            <tr> 
                <th>email</th>                
                <th>Minutes Played</th>
                <th>Logins</th>
            </tr>
            <tr v-for="user in users" :key="user.email">
                <td style="text-align:center; padding-left:4px;padding-right:4px">{{user.email}}</td>
                <td style="text-align:center; padding-left:4px;padding-right:4px">{{user.minutesPlayed}}</td>
                <td style="text-align:center;padding-left:4px; padding-right:4px" v-if="user.loginCount != 0">{{user.loginCount}}</td>
            </tr>
            <tr v-if="users.length > 0">
                <th>Total Users: {{data.players}}, Account Players: {{users.length-1}}</th>                
                <th>Minutes Played: {{data.minutes}}</th>
                <th>Hours Played: {{data.minutes/60}}</th>
            </tr>
            <tr v-if="users.length > 0">
                <th>Tracking Date: {{trackingDate.getFullYear() + "-" + parseInt(trackingDate.getMonth() + 1) + "-" + trackingDate.getDate()}}</th>   
                <th>Days Since Tracking: {{data.daysTracked}}</th>                
            </tr>
        </table>    
    </div>
  </div>     
</template>
<script>
import {
    VTextField,
    VBtn,
} from "vuetify/lib";
export default {
  components: {
    VTextField,
    VBtn,
  },
  data(){
    return{
        admin:false,
        url: window.location.href == "http://localhost:8080/"
          ? "http://localhost:7071/api/HttpTrigger1"
          : "/api/HttpTrigger1",
          users: [],
          data:{},
          trackingDate: "",
    }
  },
  mounted(){
    this.trackingDate = new Date("2023/08/12")
  },
  computed:{
   
  },
  watch:{
    
  },
  methods:{
    async login() {
       let password = document.getElementById("password").value
       let username = document.getElementById("username").value
        fetch(this.url, {
            method: "POST",
            body: JSON.stringify({
                command: "checkPassword",
                username,
                password
            }),
        }).then(async (response) => {
            let responseText = await response.text()
            if(responseText =="superAdmin"){
                this.admin = true
            }else{
                this.admin = false
                window.alert("no access")
            }
        })
    },
    async getData() {
        let password = document.getElementById("password").value
        let username = document.getElementById("username").value
        fetch(this.url, {
            method: "POST",
            body: JSON.stringify({
                command: "getData",
                username,
                password
            }),
        }).then(async (response) => {
            let responseText = await response.text()
            this.users = JSON.parse(responseText)
            this.data = this.cumulativeData(this.users)
        })
    },

    cumulativeData(users){
        if(users.length > 0){
            let data = {minutes:0, players: users.length -1, daysTracked: 0}
            users.forEach(user =>{
                data.minutes += user.minutesPlayed
                if(user.email == "GuestTracker"){
                    data.players += user.loginCount
                }else{
                    data.players += 1
                }
                
            })
            let today = new Date()
            let timeDiff = today.getTime() - this.trackingDate.getTime();
            data.daysTracked = timeDiff / (1000 * 3600 * 24);
            return data
        }
    },
  }
  
}
</script>
<style scoped>
table, th, td {
  border:1px solid black;
}
</style>